import LasLomasMain from './components/LasLomasMain'
function App() {
  return <LasLomasMain />
}

export default App
